import { Box } from '#/components/Box/Box';
import { LoadingSection } from '#/components/LoadingSection/LoadingSection';
import type { CmsApiRecommendedActionsBlockData } from '#/modules/cms/api/types/blocks/CmsApiRecommendedActionsBlock';
import { clientOnlyLazy } from '#/utils/clientOnlyLazy';

const ClientOnlyLazyCmsRecommendedActionsBlockContent = clientOnlyLazy(
  () =>
    import('./CmsRecommendedActionsBlockContent').then((m) => ({
      default: m.CmsRecommendedActionsBlockContent,
    })),
  { placeholder: <LoadingSection /> },
);

type Props = {
  data: CmsApiRecommendedActionsBlockData;
};

export function CmsRecommendedActionsBlock({ data }: Props) {
  const { volopFunction, areaOfFocus } = data;

  return (
    <Box
      qaId="recommended-actions"
      data-qa-volop-function={volopFunction}
      data-qa-area-of-focus={areaOfFocus}
    >
      <ClientOnlyLazyCmsRecommendedActionsBlockContent data={data} />
    </Box>
  );
}
